// utils/checkArrayLengths.js
export function checkArrayLengths(data) {
  try {
    if (!Array.isArray(data) || data.length === 0) {
      throw new Error("Invalid input data");
    }

    // Get the length of the first array as the reference
    const referenceLength = data[0].array.length;
    const mismatchedTitles = [`${data[0]?.title} (${data[0].array.length})`];
    const f = new Intl.ListFormat("en-us");
    // Iterate through the data to check array lengths
    data.forEach((item, index) => {
      // Assign a default title if the title is empty, null, or just whitespace
      const title =
        item.title && item?.title?.trim() !== ""
          ? item.title
          : `Column ${index + 1}`;

      if (item.array.length !== referenceLength) {
        mismatchedTitles.push(`${title} (${item.array.length})`);
      }
    });

    // Check if there are any mismatched titles
    if (mismatchedTitles.length === 1) {
      return { isSuccess: true, message: "success" };
    } else {
      data[data.length - 1] = `and ${data[data.length - 1]}`;
      return {
        isSuccess: false,
        message: `${f.format(
          mismatchedTitles
        )} do not have the same data length.`,
      };
    }
  } catch (error) {
    // Catch any unexpected errors and return a failure response
    return { isSuccess: false, message: `Function failed: ${error.message}` };
  }
}

// USAGE
// const data = [
//   { title: "", array: [{}, {}, {}] },
//   { title: "2", array: ["", "", ""] },
//   { title: null, array: [1, 2, 3, 4] },
// ];

// const result = checkArrayLengths(data);
